<h3 class="shop-settings__subscription-title">
  {{ 'shop-settings.subscription.title' | translate }}
</h3>
<p class="shop-settings__subscription-subtitle">
  {{ 'shop-settings.subscription.subtitle' | translate }}
</p>

<div class="subscription-container">
  <app-plans-cards cardType="subscription" [plans]="plans()" [useRouterLink]="false" />
</div>

<div class="payment-container">
  <div class="payment-header">
    <div class="payment-title-group">
      <h3 class="shop-settings__payment-title">
        {{ 'shop-settings.subscription.paymentMethod.title' | translate }}
      </h3>
      <p class="shop-settings__payment-subtitle">
        {{ 'shop-settings.subscription.paymentMethod.subtitle' | translate }}
      </p>
    </div>
    <button class="shop-settings__add-payment" (click)="openAddPaymentModal()">
      <div class="shop-settings__add-payment-icon">
        <app-icon [icon]="iconName.PLUS_PAYMENT" />
      </div>
      <div class="shop-settings__add-payment-text">
        {{ 'shop-settings.subscription.paymentMethod.addPaymentMethod' | translate }}
      </div>
    </button>
  </div>
  <div class="payment-cards">
    @if (paymentMethoedsLoading()) {
      <div class="dialog__loading-overlay">
        <mat-progress-spinner mode="indeterminate" diameter="40" />
      </div>
    } @else {
      @if (cards().length > 0) {
        @for (card of cards(); track card.id) {
          <div class="payment-card">
            <input
              type="radio"
              name="selectedCard"
              class="card-radio"
              [value]="card.id"
              [checked]="card.id === selectedCardId()"
              (click)="onCardSelect($event, card.id, card.stripePaymentMethodId)"
            />

            <div class="card-logo">
              @if (card.cardBrand === 'visa') {
                <app-icon class="visa-logo" [icon]="iconName.VISA" />
              } @else if (card.cardBrand === 'mastercard') {
                <app-icon class="mastercard-logo" [icon]="iconName.MASTER_CARD" />
              }
            </div>
            <div class="card-info">
              <p class="card-title">
                {{
                  'shop-settings.subscription.paymentMethod.cards.cardTypeEnding'
                    | translate: { type: card.cardBrand, num: card.fourLastCardNumbers }
                }}
              </p>
              <p class="card-expiry">
                {{
                  'shop-settings.subscription.paymentMethod.cards.cardExpiry'
                    | translate: (card.cardExpMonth | cardExpiry: card.cardExpYear)
                }}
              </p>
            </div>
            <div class="button_opt">
              <button
                class="card-options"
                (click)="handleDeletePaymentMethod(card.stripePaymentMethodId)"
              >
                <app-icon class="icon" [icon]="iconName.TRASH_BIN_LIGHT" />
              </button>
            </div>
          </div>
        }
      } @else {
        <div class="no-cards">
          <p>No Cards</p>
        </div>
      }
    }
  </div>
</div>
